import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {ProductUpdate} from './types';

interface Props {
    productUpdate: ProductUpdate;
}

export const ProductUpdateCard = (props: Props) => {
    return (
        <div className='flex gap-16'>
            <div>
                <Illustration src={props.productUpdate.illustration} width={64} height={64} />
            </div>
            <div className='flex flex-dir-col justify-sb gap-8'>
                <div className='flex flex-dir-col gap-4'>
                    <Body isBold={true}>{props.productUpdate.title}</Body>
                    <Body size='small'>{props.productUpdate.description}</Body>
                </div>
                <Link href={props.productUpdate.learnMoreLink} newTab={true} variant='primary'>
                    Learn more
                </Link>
            </div>
        </div>
    );
};
